/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Continue_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Portal_X13_Continue_MicrosoftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_continue_microsoft = /** @type {((inputs?: Portal_X13_Continue_MicrosoftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Continue_MicrosoftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Continue with Microsoft")
});